import React from 'react';
import QualtricsClickToLaunch from "./voiceOfCustomer/QualtricsClickToLaunch";
import { Typography } from "../ecosystem/";

const GiveFeedback = ({
    enabled
}) => {

    return (
        <QualtricsClickToLaunch
            class="row dashboard__give-feedback"
            enabled={
                enabled
            }>
            <div className="col-12 d-flex justify-content-center">
                <div className="d-flex flex-column">
                    <div className="always-on-qualtrics">
                        <Typography type="body-02" color="$color-secondary-a2" textAlign="center">Help us make MyBSWHealth even more useful!</Typography>
                        <Typography type="body-02" bold textAlign="center" color="$color-primary-a3">
                            <a id="bsw_qtx_home_click">
                                {"Give us feedback"}</a>
                        </Typography>
                    </div>
                </div>
            </div>
        </QualtricsClickToLaunch>
    );
}

export default GiveFeedback;
